import { render, staticRenderFns } from "./DeliveryItem.vue?vue&type=template&id=416a8909&scoped=true&"
import script from "./DeliveryItem.vue?vue&type=script&lang=ts&"
export * from "./DeliveryItem.vue?vue&type=script&lang=ts&"
import style0 from "./DeliveryItem.vue?vue&type=style&index=0&id=416a8909&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "416a8909",
  null
  
)

export default component.exports